var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticEncodeURIComponent.js
// module id = 449
// module chunks = 75